import React, { Suspense } from 'react';
import './css/App.css';
import Navbar from './components/Navbar/Navbar';
import TeacherDocumentsCard from './components/TeacherDocumentsCard/TeacherDocumentsCard';
import FeaturesSection from './components/FeaturesSection/FeaturesSection';
import FeaturedContentSection from './components/FeaturedContentSection/FeaturedContentSection';
import AboutUsSection from './components/AboutUsSection/AboutUsSection';

const OldApp = React.lazy(async () => {
  await import('./old/css/index.css');
  return import('./old/OldApp');
});

function NewSiteHome() {
  const handleGoOldWebsite = (): void => {
    window.location.href = '/old';
  };

  return (
    <div className="new-site-home-content">
      <section className="new-site-hero-section" aria-label="Öğretmenler için kahraman alanı">
        <div className="new-site-hero-overlay">
          <TeacherDocumentsCard />
          <button
            type="button"
            className="new-site-old-website-button"
            onClick={handleGoOldWebsite}
          >
            Eski Web Sitesine Git
          </button>
        </div>
      </section>

      <FeaturesSection />
      <FeaturedContentSection />
      <AboutUsSection />
    </div>
  );
}

function App() {
  const pathname = window.location.pathname;
  const isOldRoute = pathname === '/old' || pathname.startsWith('/old/');

  if (isOldRoute) {
    return (
      <Suspense fallback={null}>
        <OldApp />
      </Suspense>
    );
  }

  return (
    <div className="new-site-page">
      <Navbar />
      <NewSiteHome />
    </div>
  );
}

export default App;


